// Public runtime config injected by the server at /config.js
const injected = (typeof window !== "undefined" && window.__WELL_CONFIG__) || {};

export const CONFIG = {
  rpcUrl: injected.rpcUrl || "https://solana-devnet.g.alchemy.com/v2/alch_Mf7ek_lcOQI-DNkx5ZAZ_",
  wsUrl: injected.wsUrl || "",
  cluster: injected.cluster === "mainnet-beta" ? "mainnet-beta" : "devnet",
  programId: injected.programId || "WeLLNWvWUVAERgLRXNPPR8ZxtXvxBVHiepgY7FQMwLc",
  publicUrl: injected.publicUrl || (typeof location !== "undefined" ? location.origin : ""),
};

export function explorerTx(sig) {
  const q = CONFIG.cluster === "devnet" ? "?cluster=devnet" : "";
  return `https://explorer.solana.com/tx/${sig}${q}`;
}
export function explorerAddr(addr) {
  const q = CONFIG.cluster === "devnet" ? "?cluster=devnet" : "";
  return `https://explorer.solana.com/address/${addr}${q}`;
}
